/**
 * Created by fijas on 5/29/17.
 */
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CallbackService {
    readonly zohoUrl: string;  // URL to web api
    readonly salesForceUrl: string;  // URL to web api

    constructor(private http: HttpClient) {
        this.zohoUrl = environment.apiBaseUrl + 'ext/zoho-connections';
        this.salesForceUrl = environment.apiBaseUrl + 'ext/sales-force-connections';
    }

    saveZohoTokens(data): Observable<any> {
        return this.http.post<any>(this.zohoUrl, data);
    }

    saveSalesForceTokens(data): Observable<any> {
        return this.http.post<any>(this.salesForceUrl, data);
    }
}
